import {restHelperService} from "./rest-helper.service";

export const fieldService = {
    getField,
    getFields,
    getFieldMappedToIdAndName
};

function getField(id) {
    let request;
    if (id) {
        request = {
            "fieldId": id
        }
    }
    return restHelperService.createGetRequest("/rest/field", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function getFields(maxDistance=0, sportId=-1,own=false) {

    let request = {};
    if (maxDistance && maxDistance !== 0) {
        request["maxDistance"] = maxDistance
    }
    if (sportId && sportId !== -1) {
        request["sportId"] = sportId
    }
    if (own === true){
        request["own"]= "true"
    }
    return restHelperService.createGetRequest("/rest/field", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function getFieldMappedToIdAndName() {
    return Promise.resolve(this.getFields().then(res =>
        res.items.map(item => ({value: item.id, text: item.name})
        )));
}

